module.exports = __webpack_public_path__ + "img/misosha_shangxiang_msbg_01_23_08_21.dd6e03fe.png";